"use strict";

exports.__esModule = true;
exports.elementEditorActions = void 0;
var _immer = _interopRequireDefault(require("immer"));
var clipboard = _interopRequireWildcard(require("clipboard-polyfill/text"));
var _common = require("../../common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var elementEditorActions = exports.elementEditorActions = function elementEditorActions(_ref) {
  var getState = _ref.getState,
    setState = _ref.setState;
  return {
    /**
     * Start dragging the element at the given path.
     */
    beginDrag: function beginDrag(draggingPath) {
      setState({
        isDragging: true,
        draggingPath: draggingPath
      });
    },
    /**
     * End any active dragging operations.
     */
    endDrag: function endDrag() {
      var _getState = getState(),
        isDragging = _getState.isDragging,
        draggingPath = _getState.draggingPath;
      if (isDragging || draggingPath !== undefined) {
        setState({
          isDragging: false,
          draggingPath: undefined
        });
      }
    },
    /**
     * Open the save template dialog.
     */
    openSaveTemplateDialog: function openSaveTemplateDialog(selectedPath) {
      setState({
        selectedPath: selectedPath,
        isSaveTemplateDialogOpen: true
      });
    },
    /**
     * Close the save template dialog
     */
    closeSaveTemplateDialog: function closeSaveTemplateDialog() {
      setState({
        isSaveTemplateDialogOpen: false
      });
    },
    /**
     * Open the choose template dialog.
     */
    openChooseTemplateDialog: function openChooseTemplateDialog(selectedPath) {
      setState({
        selectedPath: selectedPath,
        isChooseTemplateDialogOpen: true
      });
    },
    /**
     * Close the choose template dialog
     */
    closeChooseTemplateDialog: function closeChooseTemplateDialog() {
      setState({
        isChooseTemplateDialogOpen: false
      });
    },
    /**
     * Determines whether the element at the specified path is selected.
     */
    isElementSelectedAt: function isElementSelectedAt(path) {
      var _getState2 = getState(),
        selectedPath = _getState2.selectedPath;
      return (0, _common.compareElementPaths)(selectedPath, path) === 0;
    },
    /**
     * Selects the element at the given path.
     */
    selectElementAt: function selectElementAt(selectedPath) {
      setState({
        selectedPath: selectedPath
      });
    },
    /**
     * Determines whether the element at the specified path can be resized.
     */
    canResizeElementAt: function canResizeElementAt(path) {
      var _getState3 = getState(),
        widgets = _getState3.widgets,
        rootElement = _getState3.rootElement;
      return (0, _common.canResizeElement)(widgets, rootElement, path);
    },
    /**
     * Get a dictionary of property names to element paths for the currently
     * selected path.
     */
    getControlPaths: function getControlPaths() {
      var _getState4 = getState(),
        selectedPath = _getState4.selectedPath,
        widgets = _getState4.widgets,
        rootElement = _getState4.rootElement;
      var controls = {};
      var element = rootElement;
      if (!Array.isArray(element) && typeof element.type === "string") {
        var widget = (0, _common.getWidget)(widgets, element.type);
        if (widget !== undefined) {
          for (var _iterator = _createForOfIteratorHelperLoose((0, _common.getSupportedWidgetProperties)(widget)), _step; !(_step = _iterator()).done;) {
            var prop = _step.value;
            controls[prop] = [];
          }
        }
      }
      var parentWidget;
      for (var i = 0; i < selectedPath.length; i++) {
        var key = selectedPath[i];
        element = element[key];
        if (element == null) {
          break;
        }
        if (!Array.isArray(element) && typeof element.type === "string") {
          var _widget = (0, _common.getWidget)(widgets, element.type);
          if (_widget !== undefined) {
            for (var _iterator2 = _createForOfIteratorHelperLoose((0, _common.getSupportedWidgetProperties)(_widget)), _step2; !(_step2 = _iterator2()).done;) {
              var _prop = _step2.value;
              if (parentWidget === undefined || !parentWidget.suppliesProps.includes(_prop)) {
                controls[_prop] = selectedPath.slice(0, i + 1);
              }
            }
          }
          parentWidget = _widget;
        }
      }
      return controls;
    },
    /**
     * Get the paths to relative height / width controls for the selected element.
     */
    getRelativeSizeControlPaths: function getRelativeSizeControlPaths() {
      var _getState5 = getState(),
        selectedPath = _getState5.selectedPath,
        rootElement = _getState5.rootElement;
      var controls = {
        width: undefined,
        height: undefined
      };
      var element = rootElement;
      var parent = rootElement;
      for (var i = 0; i < selectedPath.length; i++) {
        var key = selectedPath[i];
        element = element[key];
        if (element == null) {
          break;
        }
        if (Array.isArray(element) || typeof element.type !== "string") {
          continue;
        }
        if (parent.type === "FlexRow" || parent.type === "DeviceTable") {
          controls.width = selectedPath.slice(0, i + 1);
        } else if (parent.type === "FlexColumn") {
          controls.height = selectedPath.slice(0, i + 1);
        }
        parent = element;
      }
      return controls;
    },
    /**
     * Get the element at the given path.
     */
    getElementAt: function getElementAt(path) {
      var _getState6 = getState(),
        rootElement = _getState6.rootElement;
      return (0, _common.getElementAtPath)(rootElement, path);
    },
    /**
     * Get the widget at the given path.
     */
    getWidgetAt: function getWidgetAt(path) {
      var _getState7 = getState(),
        widgets = _getState7.widgets,
        rootElement = _getState7.rootElement;
      var element = (0, _common.getElementAtPath)(rootElement, path);
      if (element) {
        return (0, _common.getWidget)(widgets, element.type);
      }
    },
    /**
     * Get the user actions which are available at the given element path.
     */
    getAvailableUserActionsAt: function getAvailableUserActionsAt(path) {
      var _getState8 = getState(),
        widgets = _getState8.widgets,
        userActions = _getState8.userActions,
        rootElement = _getState8.rootElement;
      var contextNames = (0, _common.getSuppliedContextsInElementPath)(widgets, rootElement, path);
      return userActions.filter(function (userAction) {
        return userAction.requiresContexts.every(function (contextName) {
          return contextNames.includes(contextName);
        });
      });
    },
    /**
     * Append the given element to the element at the specified path,
     * returning the new element path if the append was successful,
     * otherwise false.
     */
    appendElementAt: function appendElementAt(parentPath, element) {
      var _getState9 = getState(),
        rootElement = _getState9.rootElement;
      var parent = (0, _common.getElementAtPath)(rootElement, parentPath);
      if (parent === undefined) {
        return false;
      }
      var targetPath = parentPath.concat("children", parent.children.length);
      var result = this.insertElementAt(targetPath, element);
      if (result === false) {
        if (parentPath.length >= 2) {
          return this.appendElementAt(parentPath.slice(0, parentPath.length - 2), element);
        }
        return false;
      }
      return result;
    },
    removeChildrenAt: function removeChildrenAt(path) {
      if (path.length < 2) {
        return false;
      }
      var index = path[path.length - 1];
      if (typeof index !== "number") {
        return false;
      }
      this.modifyElementAt(path, function (parent) {
        parent.children = [];
      });
      return true;
    },
    /**
     * Insert the given element into the specified path,
     * returning the new element path if insert was successful,
     * otherwise false.
     */
    insertElementAt: function insertElementAt(path, element) {
      var _getState0 = getState(),
        widgets = _getState0.widgets,
        rootElement = _getState0.rootElement;
      if (path.length === 0) {
        this.replaceRoot(element);
        return path;
      }
      var parentPath = path.slice(0, path.length - 2);
      var parent = (0, _common.getElementAtPath)(rootElement, parentPath);
      if (!parent) {
        return false;
      }
      var index = path[path.length - 1];
      if (typeof index !== "number") {
        return false;
      }
      if (!(0, _common.canElementPathContainElement)(widgets, rootElement, parentPath, element)) {
        return false;
      }
      setState(function () {
        return {
          selectedPath: path
        };
      });
      var newRoot = (0, _common.replaceElementAtPath)(rootElement, parentPath, function (newParent) {
        var type = newParent.type,
          props = newParent.props;
        var children = newParent.children.slice();
        if (index === 0) {
          children.unshift(element);
        } else if (index === children.length) {
          children.push(element);
        } else {
          children.splice(index, 0, element);
        }
        return {
          type: type,
          props: props,
          children: children
        };
      });
      this.replaceRoot(newRoot);
      return path;
    },
    /**
     * Insert the given element before the element at the specified path,
     * returning the new element path if insert was successful,
     * otherwise false.
     */
    insertElementBefore: function insertElementBefore(path, element) {
      var result = this.insertElementAt(path, element);
      if (result === false) {
        if (path.length >= 2) {
          return this.insertElementBefore(path.slice(0, path.length - 2), element);
        }
        return false;
      }
      return result;
    },
    /**
     * Insert the given element after the element at the specified path,
     * returning the new element path if insert was successful,
     * otherwise false.
     */
    insertElementAfter: function insertElementAfter(path, element) {
      var index = path[path.length - 1] + 1;
      var result = this.insertElementAt(path.slice(0, path.length - 1).concat(index), element);
      if (result === false) {
        if (path.length >= 2) {
          return this.insertElementBefore(path.slice(0, path.length - 2), element);
        }
        return false;
      }
      return result;
    },
    /**
     * Move an element from one path to another, returning the updated
     * element path if the move was successful, otherwise false.
     */
    moveElementAt: function moveElementAt(fromPath, toPath, newProps) {
      var _getState1 = getState(),
        widgets = _getState1.widgets,
        rootElement = _getState1.rootElement;
      if (fromPath.length === 0) {
        return false;
      }
      if ((0, _common.getPathContainsPath)(fromPath, toPath) || (0, _common.compareElementPaths)(fromPath, toPath) === 0) {
        if (newProps) {
          return this.setProps(fromPath, newProps);
        }
        return false;
      }
      var sourceElement = (0, _common.getElementAtPath)(rootElement, fromPath);
      if (sourceElement === undefined) {
        return false;
      }
      if (!(0, _common.canElementPathContainElement)(widgets, rootElement, toPath, sourceElement)) {
        if (toPath.length >= 2) {
          return this.moveElementAt(fromPath, toPath.slice(0, toPath.length - 2), newProps);
        }
        if (newProps) {
          return this.setProps(fromPath, newProps);
        }
        return false;
      }
      var rootAfterDelete = (0, _common.replaceElementAtPath)(rootElement, fromPath.slice(0, fromPath.length - 2), function (oldParent) {
        var type = oldParent.type,
          props = oldParent.props;
        var index = fromPath[fromPath.length - 1];
        var children = oldParent.children.filter(function (item, i) {
          return i !== index;
        });
        return {
          type: type,
          props: props,
          children: children
        };
      });
      var pathAfterDelete = (0, _common.calculateElementPathAfterDelete)(toPath, fromPath);
      var rootAfterInsert = (0, _common.replaceElementAtPath)(rootAfterDelete, pathAfterDelete, function (newParent) {
        var type = newParent.type,
          props = newParent.props;
        var children = [newProps ? Object.assign({}, sourceElement, {
          props: Object.assign({}, sourceElement.props, newProps)
        }) : sourceElement].concat(newParent.children);
        return {
          type: type,
          props: props,
          children: children
        };
      });
      setState(function () {
        return {
          selectedPath: pathAfterDelete
        };
      });
      this.replaceRoot(rootAfterInsert);
      return pathAfterDelete;
    },
    /**
     * Determine whether the element at the given path can be replaced
     * with a particular element.
     */
    canReplaceElementAt: function canReplaceElementAt(path, replacement) {
      var _getState10 = getState(),
        widgets = _getState10.widgets,
        rootElement = _getState10.rootElement;
      if (path.length < 2) {
        return replacement.type === rootElement.type;
      }
      var parentPath = path.slice(0, path.length - 2);
      return (0, _common.canElementPathContainElement)(widgets, rootElement, parentPath, replacement);
    },
    /**
     * Replace the element at the given path with the supplied element,
     * returning the new element path if the replacement succeeded,
     * otherwise false.
     */
    replaceElementAt: function replaceElementAt(path, replacement) {
      var _getState11 = getState(),
        widgets = _getState11.widgets,
        rootElement = _getState11.rootElement;
      setState(function () {
        return {
          selectedPath: path
        };
      });
      if (path.length >= 2) {
        var parentPath = path.slice(0, path.length - 2);
        if (!(0, _common.canElementPathContainElement)(widgets, rootElement, parentPath, replacement)) {
          return false;
        }
      }
      var newRoot = (0, _common.replaceElementAtPath)(rootElement, path, replacement);
      this.replaceRoot(newRoot);
      return path;
    },
    /**
     * Remove the element at the specified path, returning `true`
     * if the element was successfully deleted.
     */
    removeElementAt: function removeElementAt(path) {
      if (path.length < 2) {
        return false;
      }
      var index = path[path.length - 1];
      if (typeof index !== "number") {
        return false;
      }
      var parentPath = path.slice(0, path.length - 2);
      setState(function () {
        return {
          selectedPath: parentPath
        };
      });
      this.modifyElementAt(parentPath, function (parent) {
        parent.children = parent.children.filter(function (item, i) {
          return i !== index;
        });
      });
      return true;
    },
    /**
     * Copy the selected element to the clipboard.
     */
    copyElement: function copyElement() {
      var _getState12 = getState(),
        rootElement = _getState12.rootElement,
        selectedPath = _getState12.selectedPath;
      if (selectedPath.length < 2) {
        // cannot remove the root element.
        return;
      }
      var element = (0, _common.getElementAtPath)(rootElement, selectedPath);
      clipboard.writeText(JSON.stringify(element, null, 2));
    },
    /**
     * Copy the selected element to the clipboard and remove it
     * from the layout.
     */
    cutElement: function cutElement() {
      var _getState13 = getState(),
        rootElement = _getState13.rootElement,
        selectedPath = _getState13.selectedPath;
      if (selectedPath.length < 2) {
        // cannot remove the root element.
        return;
      }
      var element = (0, _common.getElementAtPath)(rootElement, selectedPath);
      clipboard.writeText(JSON.stringify(element, null, 2));
      this.removeElementAt(selectedPath);
    },
    /**
     * Paste an element definition from the clipboard and append it
     * to the currently selected element.
     */
    pasteElement: function pasteElement() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var text, element, _getState14, selectedPath, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.n = 1;
              return clipboard.readText();
            case 1:
              text = _context.v;
              if (text) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.p = 2;
              element = JSON.parse(text);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              return _context.a(2);
            case 4:
              if (element) {
                _getState14 = getState(), selectedPath = _getState14.selectedPath;
                _this.appendElementAt(selectedPath, element);
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2, 3]]);
      }))();
    },
    /**
     * Get the value of a property for a given element.
     */
    getProp: function getProp(path, name, defaultValue) {
      if (path === undefined) {
        return defaultValue;
      }
      var _getState15 = getState(),
        rootElement = _getState15.rootElement;
      var element = (0, _common.getElementAtPath)(rootElement, path);
      if (element == null || element.props === undefined) {
        return defaultValue;
      }
      var value = element.props[name];
      if (value === undefined) {
        return defaultValue;
      }
      return value;
    },
    /**
     * Set the value of a property for a given element.
     */
    setProp: function setProp(path, name, value) {
      return this.modifyElementAt(path, function (draft) {
        draft.props[name] = value;
      });
    },
    /**
     * Delete the value of a property for a given element.
     */
    deleteProp: function deleteProp(path, name) {
      return this.modifyElementAt(path, function (draft) {
        delete draft.props[name];
      });
    },
    /**
     * Set multiple properties for an element.
     */
    setProps: function setProps(path, values) {
      this.modifyElementAt(path, function (draft) {
        for (var _i = 0, _Object$keys = Object.keys(values); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          draft.props[key] = values[key];
        }
      });
    },
    /**
     * Modify the root element, invoking replaceRoot when complete.
     */
    modifyRoot: function modifyRoot(mutator) {
      var _getState16 = getState(),
        rootElement = _getState16.rootElement;
      var newRoot = (0, _immer["default"])(rootElement, mutator);
      this.replaceRoot(newRoot);
      return true;
    },
    /**
     * Modify the element at the given path.
     */
    modifyElementAt: function modifyElementAt(path, mutator) {
      var _getState17 = getState(),
        rootElement = _getState17.rootElement;
      // $FlowFixMe
      var newRoot = (0, _immer["default"])(rootElement, function (draft) {
        var element = (0, _common.getElementAtPath)(draft, path);
        if (element == null || element.props === undefined) {
          throw new Error("Failed to set value for non-existant element: " + path.join("/"));
        }
        mutator(element);
      });
      this.replaceRoot(newRoot);
      return true;
    },
    /**
     * Replace the root element with a new one, applying constraints to the resulting tree.
     */
    replaceRoot: function replaceRoot(newRoot) {
      var _getState18 = getState(),
        onChange = _getState18.onChange,
        widgets = _getState18.widgets;
      onChange((0, _common.applyElementDimensionConstraints)(widgets, newRoot));
    }
  };
};